import UserMenu from './appHeader/UserMenu';
import AppSwitcher from './appHeader/AppSwitcher';

const AppHeader = () => {
  return (
    <header className="sticky top-0 z-50 w-full border-b flex gap-4 items-center h-[var(--header-height)] p-4 bg-background">
      <div className="flex items-center gap-4 flex-auto">
        <img
          src="/profound-logo.png"
          alt="ProFound Logo"
          className="w-[48px] rounded-lg"
          loading="lazy"
        />
        <h1 className="font-semibold text-xl">Mega</h1>
      </div>
      <AppSwitcher />
      <UserMenu />
    </header>
  );
};

export default AppHeader;
